<template>
  <div class="full-popup">
    <p v-if="error" class="error">{{ error }}</p>
    <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
  </div>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader"

export default {
  name: "AppBarcodeReader",
  components: {
    StreamBarcodeReader,
  },
  data() {
    return {
      result: '',
      error: ''
    }
  },
  props: {
    doEmit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onDecode (result) {
      this.result = result
      // console.log('decoded: '+ result)
      if (this.doEmit) {
        this.$emit('barcodeRead', {qrString: this.result})
      } else {
        // this.$router.push({name: 'BatchShow', params: {id: this.result}})
      }
    },

    onError(error) {
      console.log(error)
      this.error = error.message
    },

    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    }
  }
}
</script>

<style scoped>
form {
  margin-top: 3rem;
}
</style>